'use strict';

var GridColumnAvailabilityService = function GridColumnAvailabilityService(featureToggleService, simpleHepToggleService, gridColumnAvailabilityMatchingService) {
  function isColumnAvailable(column, gridMode) {
    // check the feature
    if (column.showIfFeature && featureToggleService.isDisabled(column.showIfFeature) || column.hideIfFeature && featureToggleService.isEnabled(column.hideIfFeature)) {
      return false;
    }

    // check simple hep attributes values
    if (column.showIfSimpleHep && !simpleHepToggleService.isMatching(column.showIfSimpleHep, column.showIfSimpleHepValue) || column.hideIfSimpleHep && simpleHepToggleService.isMatching(column.hideIfSimpleHep, column.hideIfSimpleHepValue)) {
      return false;
    }
    if (column.showIfGridMode && !gridColumnAvailabilityMatchingService.isGridModeMatching(column.showIfGridMode, gridMode) || column.hideIfGridMode && gridColumnAvailabilityMatchingService.isGridModeMatching(column.hideIfGridMode, gridMode)) {
      return false;
    }
    return true;
  }
  return {
    isColumnAvailable: isColumnAvailable
  };
};
GridColumnAvailabilityService.$inject = ['FeatureToggleService', 'SimpleHepToggleService', 'GridColumnAvailabilityMatchingService'];
module.exports = GridColumnAvailabilityService;